module.exports = __webpack_public_path__ + "static/sang-logo-fc440ea8f886cb6130d12ae473a6e953.png";